<div class="activity-item">
    <div class="avatar-box">
        <app-avatar *ngIf="userData.name" [info]="userData" [size]="32" class="avatar-container" [showTooltip]="true"></app-avatar>
    </div>

    <div class="comment-detail">
        <div class="person-info">
            <div *ngIf="userData.name" class="person-name">{{ userData.name }}</div>
            <div class="operation">{{ item.action | capitalizeLower }} the <span class="field-name">{{ item.fieldName }}</span></div>
            <div class="create-time">{{ item.lastModifiedDate | date: 'MMMM d, y \'at\' h:mm a' }}</div>
        </div>
        <div class="history-info">
            <ng-container [ngSwitch]="item.fieldCategoryName">
                <ng-container *ngSwitchCase="'Attachment'">
                    <div class="attachment-old from">
                        <app-st
                            #st
                            [columns]="columns"
                            [data]="oldAttachment"
                            [page]="{ show: false }"
                        >
                        </app-st>
                    </div>
                    <img src="assets/svg/arrow-right.svg" class="info-icon">
                    <div class="attachment-new to">
                        <app-st
                            #st
                            [columns]="columns"
                            [data]="newAttachment"
                            [page]="{ show: false }"
                        >
                        </app-st>
                    </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <ng-container *ngIf="editorCategory.includes(item.fieldCategoryName) || (!item.fieldCategoryName && editorFields.includes(item.fieldName)); else valueView">
                        <div class="from">
                            <quill-view *ngIf="!isNone(oldValue); else noneTemplate" class="remove-padding-quill" [content]="oldValue" [sanitize]="true" format="html"></quill-view>
                            <ng-template #noneTemplate>
                                <div>None</div>
                            </ng-template>
                        </div>
                        <img src="assets/svg/arrow-right.svg" class="info-icon">
                        <div class="to">
                            <quill-view class="remove-padding-quill" [content]="newValue" [sanitize]="true" format="html"></quill-view>
                        </div>
                    </ng-container>
                    <ng-template #valueView>
                        <div class="from">{{ oldValue }}</div>
                        <img src="assets/svg/arrow-right.svg" class="info-icon">
                        <div class="to">{{ newValue }}</div>
                    </ng-template>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
